import { Button } from '@/components'
import { Dialog } from '@/components/UI/Dialog'
import dialogStyles from '@/components/UI/Dialog.module.css'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { PointHistoryList } from './PointHistoryList'

export type PointHistoryEntry = {
  id: number | string
  label: string
  point: number
  acquiredAt: string
}

type Props = {
  items: PointHistoryEntry[]
  isOpen: boolean
  onClose: () => void
}

/** ポイント履歴ダイアログ */
export const DialogPointHistory: FC<Props> = ({ items, isOpen, onClose }) => {
  const { t } = useTranslation()
  return (
    <Dialog selectorState={isOpen} closeFunc={onClose} title={t('point_history.title', 'ポイント履歴')}>
      {/* タイトル〜リストの余白（24px）。タイトル上の24pxは Dialog header の paddingTop が担う */}
      <div className="mt-6">
        {/* scrollArea が Dialog body の padding を打ち消し、スクロールバーをダイアログ端に寄せる */}
        <div className={`${dialogStyles.scrollArea} max-h-[60vh]`}>
          <PointHistoryList items={items} />
        </div>
        {/* リスト〜ボタンの余白（24px）。ボタン下の24pxは Dialog body の paddingBottom が担うため pb-* は付けない */}
        <div className="mt-6 w-full">
          <Button label="OK" variant={'primary'} size="md" fullWidth onClick={onClose} />
        </div>
      </div>
    </Dialog>
  )
}
